import { jsxs as m, jsx as e, Fragment as v } from "react/jsx-runtime";
import { Divider as h } from "./index.es24.js";
import u from "classnames";
import { useEffect as c } from "react";
import o from "./index.es5591.js";
import { useCard as N } from "./index.es795.js";
import { useScreenZoom as x } from "./index.es589.js";
import { Heading as I } from "./index.es507.js";
import { MenuText as y } from "./index.es508.js";
const P = ({ headline: i, description: r, Thumbnail: s, hasDivider: p }) => {
  const { zoomPercentage: d } = x(), { registerHeadlineId: t, registerDescriptionId: a, headlineId: l, descriptionId: f } = N();
  c(() => {
    i && t();
  }, [i, t]), c(() => {
    r && a();
  }, [r, a]);
  const n = d >= 200, g = u(o.wrapper, {
    [o.noDescription]: !r
  });
  return /* @__PURE__ */ m("div", { className: o.header, children: [
    /* @__PURE__ */ m("div", { className: g, children: [
      !!s && /* @__PURE__ */ e(v, { children: s }),
      /* @__PURE__ */ m("div", { className: o.content, children: [
        /* @__PURE__ */ e(
          I,
          {
            variant: "h5",
            color: "primary",
            isEllipsis: !n,
            element: "p",
            id: l,
            children: i
          }
        ),
        r && /* @__PURE__ */ e(
          y,
          {
            clamp: n ? void 0 : 2,
            color: "gray",
            variant: "regular",
            element: "p",
            id: f,
            children: r
          }
        )
      ] })
    ] }),
    p && /* @__PURE__ */ e(h, {})
  ] });
};
export {
  P as CardHeader
};
//# sourceMappingURL=index.es796.js.map
